<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" validation>
              <v-text-field
                  prepend-icon="person"
                  name="phone"
                  label="Телефон"
                  type="text"
                  v-model="phone"
                  :rules="phoneRules"
                  mask="+7 (###) ###-##-##"
                  validate-on-blur
                  outline
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="onSubmit"
                :loading="loading"
                :disabled="!valid || loading"
            >Отправить код</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        phone: '+7',
        valid: false,
        phoneRules: [
          v => !!v || 'Обязательное поле',
          v => /^[0-9+]{11,12}$/u.test(v) || 'Телефон не корректный'
        ]
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      onSubmit () {
        if (this.$refs.form.validate()) {
          const user = {
            phone: this.phone
          }

          this.$store.dispatch('passwordResetUser', user)
            .then(() => {
              this.$router.push('/password-recovery/confirm')
            })
            .catch((e) => {
              this.$router.push('/')
            })
        }
      }
    },
    created () {
      this.$store.commit('setPageTitle', 'Восстановление пароля')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Auth/PasswordRecovery.vue